import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class CollectionCampaignApi extends BaseApi {
    constructor(client, basePath = '/collection-campaigns') {
        super(client, basePath);
    }

    async update(id, data) {
        try {
            const response = await this.client.patch(`${this.basePath}/${id}`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async targets() {
        try {
            const response = await this.client.get(`${this.basePath}/targets`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async progress(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/progress`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async launch(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/launch`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async resync(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/resync`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async cancel(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/cancel`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async remind(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/remind`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async searchRecords(assignmentId, q) {
        try {
            const response = await this.client.get(`/collection-assignments/${assignmentId}/search`, { params: { q } });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async createRecord(assignmentId, body) {
        try {
            const response = await this.client.post(`/collection-assignments/${assignmentId}/create`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async listRecords(assignmentId) {
        try {
            const response = await this.client.get(`/collection-assignments/${assignmentId}/records`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateRecord(assignmentId, recordId, body) {
        try {
            const response = await this.client.patch(`/collection-assignments/${assignmentId}/records/${recordId}`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async completeAssignment(assignmentId) {
        try {
            const response = await this.client.post(`/collection-assignments/${assignmentId}/complete`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async linkRecord(assignmentId, entityId) {
        try {
            const response = await this.client.post(`/collection-assignments/${assignmentId}/link`, { entityId });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
